import { useContext, useState } from "react";

import classes from "./BookShelfDesktop.module.css";

import RecipeBookClosed from "../../components/BookShelf/RecipeBookClosed/RecipeBookClosed";
import LoadingSpinner from "../../UI/LoadingSpinner";

import ShelfContext from "../../store/shelf-context";

import useWindowDimensions from "../../hooks/useWindowDimensions";


// Page where user books can be accessed, formatted for Desktop
const BookShelfDesktop = () => {
  const shelfCtx = useContext(ShelfContext);
  const [isLoading, setIsLoading] = useState(true);

  
  const handleImageLoad = () => {
    setIsLoading(false);
  };

  // set x and y coordinates where books should sit on the bookshelf
  const book_x_position = [
    1, 13, 25, 37, 76, 88, 1, 13, 25, 37, 49, 61, 73, 85, 97,
  ];
  const book_y_position = [6, 6, 6, 6, 6, 6, 56, 56, 56, 56, 56, 56, 56];

  const { height, width } = useWindowDimensions();

  const startX = width / 2 - 295;
  const startY = height / 2 - 260;

  // set the x and y coordinates of the book objects
  const books = shelfCtx.books.map((book, index) => {
    let posX;
    let posY;

    posX = startX + book_x_position[index] * 6;
    posY = startY + book_y_position[index] * 6;

    return (
      <RecipeBookClosed
        key={index}
        book={book}
        number={index}
        posX={posX}
        posY={posY}
      />
    );
  });

  return (
    
    <div className={classes.bookShelfOuterContainer} style={{backgroundImage: "url(" + process.env.REACT_APP_ASSETS_URL + "/assets/gen_graphics/bookshelf_full_1.png)"}}>
      {isLoading && <LoadingSpinner asOverlay />}
      <img
        className={classes.emptyShelf}
        src={"/assets/gen_graphics/book_shelf_empty.svg"}
        alt="new"
        onLoad={handleImageLoad}
        style={{ display: isLoading ? 'none' : 'block' }}
      />
      <div>{books}</div>
    </div>
  );
};

export default BookShelfDesktop;
